import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid } from '@mui/material';
import CommonTable from 'components/commonTable/CommonTable';
import ComplianceUpload from './ComplianceUpload';
import { useLocation } from 'react-router-dom';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';
import Loader from 'components/loader/Loader';
import LocationDropdown from 'components/LocationDropdown/LocationDropdown';
import CommonSDF from 'components/commonSDF/CommonSdf';

function ComplianceTab(props) {
  const { value, handleChangePage, handleChangeRowsPerPage, page, rowsPerPage } = props;
  const [showTabs, setShowTabs] = useState(true);
  const role = localStorage.getItem('role');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const uploadParam = params.get('upload');
    setShowTabs(uploadParam !== 'true');
  }, [location.search]);

  const handleChange = (event, newValue) => {
    props?.handleChange(newValue);
  };

  const handleLocationChange = (location) => {
    props.onInputChange(location);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {showTabs && (
        <TabContext value={value}>
          {/* Tab List Section */}
          <Box className="tabBoxStyle contentBoxStyle" sx={{
            borderBottom: '1px solid #e0e0e0',
            mb: 3
          }}>
            <TabList
              onChange={handleChange}
              aria-label="compliance tabs"
              TabIndicatorProps={{
                style: { backgroundColor: 'white' },
              }}
            >
              {!props?.accessForOnlyViewSubVendor && (
                <Tab label="Sub-Vendor" value="2" className="tabStyle" />
              )}
              {!props?.accessForOnlyViewDriver && (
                <Tab label="Driver" value="3" className="tabStyle" />
              )}
              {!props?.accessForOnlyViewVehicle && (
                <Tab label="Vehicle" value="4" className="tabStyle" />
              )}
              {role !== 'adminCompany' && role !== 'vendorCompany' && (
                <Tab label="Self" value="5" className="tabStyle" />
              )}
            </TabList>
          </Box>

          {/* Filters Row */}
          {value !== '5' && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'flex-start', xs: 'flex-start' },
                gap: 1,
                flexWrap: 'nowrap',
                overflowX: 'auto',
                mb: 3,
                px: 1,
              }}
            >
              {/* City Dropdown - Fixed width */}
              <Box    
              sx={{
                flexShrink: 0,
                width: { xs: '140px', sm: '160px', md: '200px', lg: '200px' },
              }}>
                <LocationDropdown
                  onChange={handleLocationChange}
                  placeholder="All City"
                  fullWidth
                />
              </Box>

              {/* Search & Filters - Takes remaining space */}
              <Box  
              sx={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'flex-end',
                minWidth: 0,
              }}>
                <CommonSDF
                  onSearch={props?.onSearch}
                  searchValue={props?.searchValue}
                  defaultStatus={props.defaultStatus}
                  filterdata={props?.filterdata}
                  onFilterChange={props?.onFilterChange}
                  onRestFilter={props?.onRestFilter}
                />
              </Box>
            </Box>
          )}

          {/* Table Panels */}
          <TabPanel value="2" sx={{ p: 0 }}>
            {props?.loader ? (
              <Loader />
            ) : (
              <CommonTable
                data={props?.tableData}
                onClickTableVendor={props?.onClickTableVendor}
                handleChangePage={props?.handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={props?.page}
                rowsPerPage={props?.rowsPerPage}
                isClickable={true}
              />
            )}
          </TabPanel>
          <TabPanel value="3" sx={{ p: 0 }}>
            {props?.loader ? (
              <Loader />
            ) : (
              <CommonTable
                data={props?.tableData}
                onClickTableVendor={props?.onClickTableVendor}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
                isClickable={true}
              />
            )}
          </TabPanel>
          <TabPanel value="4" sx={{ p: 0 }}>
            {props?.loader ? (
              <Loader />
            ) : (
              <CommonTable
                data={props?.tableData}
                onClickTableVendor={props?.onClickTableVendor}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
                isClickable={true}
              />
            )}
          </TabPanel>
          <TabPanel value="5" sx={{ p: 0 }}>
            <ComplianceUpload tabName={'Self'} />
          </TabPanel>
        </TabContext>
      )}
      {!showTabs && <ComplianceUpload />}
    </Box>
  );
}

export default ComplianceTab;